/**
 * @generated SignedSource<<ee6842fd777d6588baf8a5e034e074a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useCreateUserRefreshViewerQuery$variables = {};
export type useCreateUserRefreshViewerQuery$data = {
  readonly viewer: {
    readonly user?: {
      readonly id: string;
    } | null;
  } | null;
};
export type useCreateUserRefreshViewerQuery = {
  response: useCreateUserRefreshViewerQuery$data;
  variables: useCreateUserRefreshViewerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GalleryUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateUserRefreshViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCreateUserRefreshViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cfef6f994aa8676a2d8d1bd9d3197ceb",
    "id": null,
    "metadata": {},
    "name": "useCreateUserRefreshViewerQuery",
    "operationKind": "query",
    "text": "query useCreateUserRefreshViewerQuery {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b37d5d3856da55fc9bd753ae272e3892";

export default node;
